import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { t } from 'i18next';
import { isErrorStatus, isLoadingStatus, useResource } from 'json-api-hooks';
import React, { FC } from 'react';
import FontAwesome from 'react-fontawesome';

import Button from '../../components/././Button';
import AttributeList from '../../components/AttributeList';
import AttributeListItem from '../../components/AttributeListItem';
import Card from '../../components/Card';
import CardContent from '../../components/Card/CardContent';
import HeaderWithFloat from '../../components/HeaderWithFloat';
import Heading from '../../components/Heading';
import HeadingContext from '../../components/Heading/HeadingContext';
import { LoadingCard } from '../../components/Loading';
import PriorityDetail from '../../details/PriorityDetail';
import { useVisitPostalCode } from '../../lib/helpers';

interface PostalCodeDialogProps {
  id: string;
  onClose: () => void;
}

const PostalCodeOverlay: FC<PostalCodeDialogProps> = ({ id, onClose }) => {
  const { visitPostalCode } = useVisitPostalCode();
  const [postalCode, status] = useResource({ type: 'postal_codes', id });

  if (isLoadingStatus(status)) {
    return <LoadingCard />;
  }

  if (isErrorStatus(status) || !postalCode) {
    return (
      <HeadingContext>
        <Card>
          <CardContent endSpacing>
            <Heading>Er ging iets mis</Heading>
          </CardContent>
        </Card>
      </HeadingContext>
    );
  }

  const closeButton = (
    <IconButton size="small" title={t('form.close')} type="button" onClick={onClose}>
      <FontAwesome name="close" />
    </IconButton>
  );

  return (
    <HeadingContext>
      <Card>
        <CardContent>
          <HeaderWithFloat float={closeButton} title={postalCode.attributes.name} />
          <Box component="strong" sx={{ marginBottom: '.4em' }}>
            {t('table.streets.columns.priority')}
          </Box>
          <PriorityDetail height="0.7rem" priority={postalCode.attributes.meanPriority} />
        </CardContent>
        <CardContent endSpacing>
          <Box component="strong" sx={{ lineHeight: '1.5em' }}>
            {t('postcode.stats.heading')}
          </Box>
          <AttributeList>
            <AttributeListItem label={t('postcode.table.active')}>
              {postalCode.attributes.activeCount}
            </AttributeListItem>
            <AttributeListItem label={t('postcode.table.volunteers')}>
              {postalCode.attributes.volunteersCount}
            </AttributeListItem>
            <AttributeListItem label={t('postcode.table.doors')}>{postalCode.attributes.doorsCount}</AttributeListItem>
          </AttributeList>
          <Button onClick={() => visitPostalCode(postalCode.attributes.postalDigits)}>Aan de slag!</Button>
        </CardContent>
      </Card>
    </HeadingContext>
  );
};

export default PostalCodeOverlay;
